import MainFeaturedPost from './mainFeaturedPost';

export default MainFeaturedPost;
